module.exports = __webpack_public_path__ + "static/media/Income-Tax2.62328a66.png";